// extracted by mini-css-extract-plugin
module.exports = {"root":"LanguageList_root__Bj4qO","languageListItem":"LanguageList_languageListItem__9DME5"};